import React from "react";
import { Card } from "Components";
import styled from "styled-components";
import { Body1 } from "melodies-source/Text";
import { useArtistEventContext } from "contexts/ArtistEventContext";
import { CardTitle } from "../Components/CardTitle";
import { useBackstageUrl } from "hooks/useBackstageUrl";

export const Sweepstakes: React.FC = () => {
  const { eventId } = useArtistEventContext();
  const { goToBackstageUrl } = useBackstageUrl();

  return (
    <Card
      action={{
        text: "Go to Event Sweepstakes",
        onClick: () => goToBackstageUrl(`/${eventId}`),
      }}
    >
      <Container>
        <CardTitle>Sweepstakes</CardTitle>
        <Content>
          <Body1>
            To select or contact winners please visit the sweepstakes tab on
            Backstage.
          </Body1>
        </Content>
      </Container>
    </Card>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;
`;

const Content = styled.div`
  padding: 5px 0 0;
  height: max-content;
  flex: 1;

  ${Body1} {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background-color: var(--content-background-color);
    padding: 40px;
    text-align: center;
    color: var(--text-color);
    font-size: 16px;
    height: 100%;
  }
`;
